import { Table } from 'antd';
import styled from 'styled-components';
import { IThemeProvider } from '../../../styles/theme';
import { LabelRegularBoldM, LabelRegularM } from '../../../styles/globals';
import { ITableRow } from '../../../services/dashboard';

export const DepartmentsCont = styled.div`
  padding: 24px 12px 24px 0;
`;

export const TableHeader = styled(LabelRegularBoldM)`
  letter-spacing: 0.08em;
  text-transform: uppercase;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const TableData = styled(LabelRegularM)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
  `}
`;

export const ReportYes = styled(TableData)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.primary[100]};
    font-weight: 600;
  `}
`;

export const ReportNo = styled(TableData)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[50]};
  `}
`;

export const SpinnerCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
`;

export const StyledDepartmentsTable: typeof Table = styled(Table)<ITableRow>`
  .ant-table-body {
    width: 99%;
    overflow-x: hidden !important;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .ant-table {
    background: transparent;

    table {
      ${({ theme }: IThemeProvider) => `
        border-spacing: 0 ${theme.layout.spacing.mili};
      `}

      .ant-table-thead {
        th {
          background: transparent;
          ${({ theme }: IThemeProvider) => `
            padding: 8px ${theme.layout.spacing.centy};
            border-top: 1px solid ${theme.colors.neutral.primary[30]};
          `}
          &:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
            content: none;
          }
        }

        .ant-table-column-title {
          flex: unset;
          ${({ theme }: IThemeProvider) => `
            margin-right: ${theme.layout.spacing.centy};
          `}
        }

        .ant-table-filter-column,
        .ant-table-column-sorters {
          justify-content: flex-start;

          .ant-table-column-sorter-inner .active {
            color: ${({ theme }: IThemeProvider) => theme.colors.secondary[100]};
          }
        }
      }

      .ant-table-tbody {
        tr {
          ${({ theme }: IThemeProvider) => `
            border-radius: ${theme.layout.spacing.mikro};
            box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
          `}

          .ant-table-cell {
            height: 48px;
            ${({ theme }: IThemeProvider) => `
              background: ${theme.colors.neutral.primary[0]};
              padding: 0 ${theme.layout.spacing.centy};
            `}
          }

          td:first-child {
            ${({ theme }: IThemeProvider) => `
              border-top-left-radius: ${theme.layout.spacing.mikro};
              border-bottom-left-radius: ${theme.layout.spacing.mikro};
            `}
          }

          td:last-child {
            ${({ theme }: IThemeProvider) => `
              border-top-right-radius: ${theme.layout.spacing.mikro};
              border-bottom-right-radius: ${theme.layout.spacing.mikro};
            `}
          }
        }
      }
    }
  }
` as typeof Table;
